import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const dataMonitoringApi = createApi({
  baseQuery,
  reducerPath: 'dataMonitoringApi',
  endpoints: builder => ({
    getDataMonitoringData: builder.query<any, any>({
      query: ({ study_id, application }) => ({
        url: `${formatString(endPoints.dataMonitoring.select, {
          key: urlKeys.study_id,
          value: study_id
        })}?application=${application}&application_section=${'CONDUCT'}`,
        method: 'GET'
      })
    }),

    updateDataMonitoringData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(endPoints.dataMonitoring.update, {
          key: urlKeys.study_id,
          value: study_id
        })}?country=${country}&application=${application}&application_section=${'CONDUCT'}`,
        method: 'PUT',
        body: data
      })
    })
  })
});

export const { useLazyGetDataMonitoringDataQuery, useUpdateDataMonitoringDataMutation } = dataMonitoringApi;
